import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import {AxiosResponse} from "axios";
import ApiService from "@/core/services/ApiService";
import type {ScoreSystemType} from "@/types/ScoreSystemType";

@Module
export default class ScoreSystemModule extends VuexModule {
    errors = {};
    scoreSystemData = {} as ScoreSystemType;
    currentScoreSystem = {} as ScoreSystemType;
    showHakaiAchievements = false;
    showCertificationAchievements = false;

    get getCurrentScoreSystem() {
        return this.currentScoreSystem;
    }

    get getScoreSystemData(){
        return this.scoreSystemData;
    }

    get getShowHakaiAchievements(){
        return this.showHakaiAchievements;
    }

    get getShowCertificationAchievements(){
        return this.showCertificationAchievements;
    }

    @Action
    async [Actions.GET_SCORE_SYSTEM](payload: string | { id: string | number; page?: number }) {
        const id = typeof payload === "object" ? payload.id : payload;
        const page = typeof payload === "object" ? payload.page : undefined;
        const url = page ? `/club/scoreboard/${id}?page=${page}` : `/club/scoreboard/${id}`;
        try {
            const response: AxiosResponse<any> = await ApiService.get(url);
            this.context.commit(Mutations.SET_CURRENT_SCORE_SYSTEM_DATA, response.data);
        } catch (error) {
            this.context.commit(Mutations.SET_CURRENT_SCORE_SYSTEM_DATA, {});
        }
    }

    @Mutation
    [Mutations.SET_SCORE_SYSTEM_DATA](scoreSystem: ScoreSystemType) {
    
        this.scoreSystemData = scoreSystem;
    }

    @Mutation
    [Mutations.SET_CURRENT_SCORE_SYSTEM_DATA](scoreSystem: ScoreSystemType) {
        this.currentScoreSystem = scoreSystem;
    }

    @Mutation
    [Mutations.SET_SHOW_HAKAI_ACHIEVEMENTS](show: boolean) {
        this.showHakaiAchievements = show;
    }

    @Mutation
    [Mutations.SET_SHOW_CERTIFICATION_ACHIEVEMENTS](show: boolean) {
        this.showCertificationAchievements = show;
    }
}